import CONFIG from '@config';
import algoliasearch from 'algoliasearch/lite';

export default algoliasearch(CONFIG.algolia.app_id, CONFIG.algolia.search_key);
